export default "__VITE_ASSET__533dc605__"